import {
  mobileReg, idCardReg,
} from '@/constant/regExp';

// 操作类型
const OPERATE_TYPE = {
  CREATE: '新增操作',
  UPDATE: '更新操作',
  READ: '查询操作',
  DELETE: '删除操作',
  BIND_ADMIN: '绑定管理员',
  UNBIND_ADMIN: '解绑管理员',
};

const fromData = {
  tenantName: null,
  contacts: null,
  mobile: null,
  remark: '',
  freshCompany: false,
  dataAuthLevel: null,
  tenantCompanyType: null,
  businessCreditName: '',
  businessCreditCode: '',
  status: 'ENABLED',
  ext: {
    belongCreditCode: '',
    belongEnterpriseName: '',
  },
  property: {
    operateType: 'BINDING',
    properties: [
      {
        key: 'MANAGER_NAME',
        value: '',
        type: 'ENTERPRISE_MANAGER',
      }, {
        key: 'MANAGER_MOBILE',
        value: '',
        type: 'ENTERPRISE_MANAGER',
      },
    ],
  },
  parentTenant: '',
};
const validatePhone = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('请输入手机号'));
  } else if (!mobileReg.test(value)) {
    callback(new Error('手机号格式不正确'));
  } else {
    callback();
  }
};
const validateIdCard = (rule, value, callback) => {
  if (value && !idCardReg.test(value)) {
    callback(new Error('身份证号格式不正确'));
  } else {
    callback();
  }
};
const rules = {
  tenantName: [
    { required: true, message: '请输入', trigger: 'blur' },
    {
      min: 2, max: 50, message: '大于2小于50个字符', trigger: 'blur',
    },
  ],
  contacts: [
    { required: true, message: '请输入', trigger: 'blur' },
    {
      min: 2, max: 50, message: '大于2小于50个字符', trigger: 'blur',
    },
  ],
  mobile: [
    { required: true, message: '请输入手机号', trigger: 'blur' },
    { validator: validatePhone, trigger: 'blur' },
  ],
  'ext.belongEnterpriseName': [
    { required: true, message: '请输入公司名称', trigger: 'change' },
  ],
  'ext.belongCreditCode': [
    { required: true, message: '请输入统一社会信用代码', trigger: 'change' },
  ],
};
const echarts = {};
export {
  validateIdCard,
  rules,
  fromData,
  echarts,
  OPERATE_TYPE,
};
